import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import Auth, { type SendPasswordResetEmailResponse } from 'src/services/api/auth/Auth';

type ApiResponse = SendPasswordResetEmailResponse
type Response = ApiResponse;

type Request = {
    email: string;
}

export const useSendPasswordResetEmail = () => {
    return useMutation<Response, IStandardErrorResponse, Request>(
        (payload) => Auth.sendPasswordResetEmail(payload.email)
    );
};